import React, { useEffect, useState } from 'react';
import { Divider } from '@wix/wix-ui-tpa/cssVars';
import ItemGenerator from './ItemGenerator/ItemGenerator';
import {
  st as dividerStyle,
  classes,
} from '../../../../../Shared/SharedDivider.st.css';
import {
  classes as itemWrapperClasses,
  style as st,
} from './ItemWrapper.st.css';
import useObservable from '../../../../../../Shared/Hooks/useObservable.Hook';
import { getSelectedItems } from '../../../../../Services/SelectedItems.service';
import {
  getAppSettings,
  getSettingsData,
} from '../../../../../Services/AppSettings.service';
import { getTableSettings } from '../../../../../Services/TableSettings.service';
import { TableColumns } from '../../../../../../Constants/TableHeader.Constants';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import stylesParams from '../../../../../../stylesParams';
import settingsParams from '../../../../../../settingsParams';

const ItemWrapper = (props: any) => {
  const {
    item,
    setHoveredOrSelectedItems,
    hoveredOrSelectedItems,
    getPreviousItems,
    index,
  } = props;
  const [, settingsData]: any = useObservable(getSettingsData());
  const settings = useSettings();
  const styles = useStyles();

  const isEditor3: boolean = settings.get(settingsParams.isEditor3) ?? false;
  let dividerWidth = settingsData?.settings?.designSettings?.dividerWidth ?? 1;
  if (isEditor3) {
    dividerWidth = styles.get(stylesParams.borderWidth) ?? dividerWidth;
  }
  const membersDividerWidth =
    settingsData?.settings?.designSettings?.memberProfileDividerWidth ?? 1;
  const [state, setState] = useState<any>({
    selectedItems: [],
  });

  const [, selectedItems]: any = useObservable(getSelectedItems());
  const [, appSettings]: any = useObservable(getAppSettings());
  const [, tableDisplaySettings]: any = useObservable(getTableSettings());
  const displaySearch =
    tableDisplaySettings &&
    tableDisplaySettings.find(
      (data: any) => data.id === TableColumns.SEARCH_BAR,
    );
  const isMobile = appSettings !== undefined ? appSettings?.isMobile : '';
  const isEditorX: boolean = appSettings?.isEditor_X ?? false;
  const showTopDivider = isMobile
    ? !displaySearch?.value || (selectedItems && selectedItems.length > 0)
    : true;
  const isMembersArea = appSettings?.isMembersArea ?? false;

  useEffect(() => {
    if (selectedItems && selectedItems.length > 0) {
      let tempSelectedItems: any = [];
      const previousSelectedItem = getPreviousItems(selectedItems);
      tempSelectedItems = [...previousSelectedItem, ...selectedItems];
      setState((prev: any) => ({
        ...prev,
        selectedItems: tempSelectedItems,
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        selectedItems: [],
      }));
    }
  }, [getPreviousItems, selectedItems]);
  const hoverEffect =
    hoveredOrSelectedItems.includes(item.id) ||
    (state.selectedItems && state.selectedItems.includes(item.id));
  return (
    <div
      onMouseEnter={() => {
        setHoveredOrSelectedItems('MouseEnter', item.id);
      }}
      onMouseLeave={() => {
        setHoveredOrSelectedItems('MouseLeave', item.id);
      }}
    >
      <div
        className={st(
          itemWrapperClasses.root,
          {
            checked: selectedItems && selectedItems.includes(item.id),
            isMembersArea,
          },
          itemWrapperClasses.itemWrapperGeneratorContainer,
        )}
      >
        {index === 0 && showTopDivider ? (
          <div
            className={dividerStyle(classes.dividerContainer, {
              hoverEffect,
              isMembersArea,
              isEditorX,
            })}
          >
            <Divider
              data-hook={`item-wrapper-top-divider-${item.id}`}
              className={
                hoverEffect
                  ? dividerStyle(
                      classes.dividerStyle,
                      { isEditor3 },
                      classes[
                        `dividerStyle_${
                          isMembersArea ? membersDividerWidth : dividerWidth
                        }_`
                      ],
                    )
                  : dividerStyle(
                      classes.dividerStyle,
                      { isEditorX, isMobile, isEditor3 },
                      classes[
                        `dividerStyle_${
                          isMembersArea ? membersDividerWidth : dividerWidth
                        }_`
                      ],
                    )
              }
            />
          </div>
        ) : null}
        <ItemGenerator item={item} />
      </div>
      <div
        className={dividerStyle(classes.dividerContainer, {
          hoverEffect,
          isMembersArea,
          isEditorX,
        })}
      >
        <Divider
          data-hook={`item-wrapper-bottom-divider-${item.id}`}
          className={
            hoverEffect
              ? dividerStyle(
                  classes.dividerStyle,
                  { isEditor3 },
                  classes[
                    `dividerStyle_${
                      isMembersArea ? membersDividerWidth : dividerWidth
                    }_`
                  ],
                )
              : dividerStyle(
                  classes.dividerStyle,
                  { isEditorX, isMobile, isMembersArea, isEditor3 },
                  classes[
                    `dividerStyle_${
                      isMembersArea ? membersDividerWidth : dividerWidth
                    }_`
                  ],
                )
          }
        />
      </div>
    </div>
  );
};

export default ItemWrapper;
